import { useCallback, useState } from "react"
import ReactDOM from "react-dom";
import { useDispatch, useSelector } from "react-redux";

import Button from "../../../common/Button"
import Backdrop from "../../../common/modal/Backdrop";
import Modal from "../../../common/Modal";
import ModalInnerWrapper from "../../../common/ModalInnerWrapper";
import AddNewTrip from "./AddNewTrip";
import ManualRideEntry from "./ManualRideEntry";
import { dennyFurtherTrips } from "../../../../lib/verifications";
import { useUserTabEditPermissionDisabled } from "../../../../lib/usersPermissions";
import GeneratePDFDownload from "../Shared/GeneratePDFDownload";
import { caseHaseRides, patientHasCompleteAddress } from "../../../../lib/script";
import { transportationFunctions } from "../../../../lib/transportation";

const TransportationControls = ({ inWorkQ }) => {
    let userPermission = useUserTabEditPermissionDisabled('transportation_create_trip')
    let manualTripPermission = useUserTabEditPermissionDisabled('transportation_create_trip_manual')

    const dispatch = useDispatch()
    const userToken = useSelector(state => state.user.token)
    const [isModalOpened, setisModalOpened] = useState(false)
    const [isManualModalOpened, setIsManualModalOpened] = useState(false)
    const [isOverflowDisabled, setIsOverflowDisabled] = useState(true)
    const activeCase = useSelector(state => state.case.activeCase)
    const hasContractSigned = !!activeCase?.case_transportation?.has_contract_signed

    const refreshClientNumberAfterAgreement = useCallback(async () => {
        if (!activeCase?.case?.id || !userToken) {
            return
        }
        await transportationFunctions.refreshClientNumberAfterAgreement(
            userToken,
            activeCase.case.id,
            dispatch,
            inWorkQ,
        )
    }, [activeCase?.case?.id, userToken, dispatch, inWorkQ])

    const openModalHandler = () => {
        setIsOverflowDisabled(true)
        setisModalOpened(true)
    }

    const closeModalHandler = () => {
        setisModalOpened(false)
    }

    const openManualModalHandler = () => {
        setIsManualModalOpened(true)
    }

    const closeManualModalHandler = () => {
        setIsManualModalOpened(false)
    }

    const hasCompleteAddress = patientHasCompleteAddress(activeCase?.patient?.contact_information)
    const canCreateTrip = userPermission && hasCompleteAddress
    const canCreateManualTrip = manualTripPermission && hasCompleteAddress
    const denyTrips = dennyFurtherTrips(activeCase?.case_transportation)

    return <>
        <div className="flex-container">
        {caseHaseRides(activeCase?.case_transportation) && <GeneratePDFDownload url={'case-transportation-invoice'} boxStyle={'btn_grey'} fileName={'transportation_invoice.pdf'}>
            <i className="ti ti-printer"></i> Statement
        </GeneratePDFDownload>}
        {!hasContractSigned && (
            <GeneratePDFDownload
                url={'case-transportation-agreement'}
                boxStyle={'btn_grey'}
                fileName={'transportation_agreement.pdf'}
                onDownloadSuccess={refreshClientNumberAfterAgreement}
            >
                <i className="ti ti-printer"></i> Agreement
            </GeneratePDFDownload>
        )}
        {canCreateTrip && <Button click={openModalHandler} isDisabled={denyTrips?.is_denied} messages={denyTrips?.message}>
            <i className="ti ti-square-plus"></i>New Trip
        </Button>}
        {canCreateManualTrip && <Button click={openManualModalHandler} isDisabled={denyTrips?.is_denied} messages={denyTrips?.message}>
            <i className="ti ti-square-plus"></i>Manual Lyft Entry
        </Button>}

        </div>
        {isModalOpened && <>
            {ReactDOM.createPortal(
                <Backdrop hide={closeModalHandler} />,
                document.getElementById("backdrop-root")
            )}  
            {ReactDOM.createPortal(
                <Modal>
                    <ModalInnerWrapper closeModal={closeModalHandler} modalTitle={'New Trip'} noOverflow={isOverflowDisabled}>
                        <AddNewTrip closeModal={closeModalHandler} disableOverflow={(value) => {setIsOverflowDisabled(value)}}/>
                    </ModalInnerWrapper>
                </Modal>,
                document.getElementById("overlay-root")
            )}          
        </>}
        {isManualModalOpened && <>
            {ReactDOM.createPortal(
                <Backdrop hide={closeManualModalHandler} />,
                document.getElementById("backdrop-root")
            )}
            {ReactDOM.createPortal(
                <Modal>
                    <ModalInnerWrapper closeModal={closeManualModalHandler} modalTitle={'Manual Lyft Entry'}>
                        <ManualRideEntry closeModal={closeManualModalHandler} />
                    </ModalInnerWrapper>
                </Modal>,
                document.getElementById("overlay-root")
            )}
        </>}
    </>
}

export default TransportationControls
